import { render } from "./Loader.vue?vue&type=template&id=87b8843a&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=87b8843a&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87b8843a"]])

export default __exports__